import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface ISaveState {
  uuid: string;
  title: string;
  description: string;
  curriculum: number;
  tags: number[];
  folderUUID: string;
  isOwner: boolean;
  exportable: boolean;
  readable: boolean;
  grade: number;
  subject: number;
  isPurchased: boolean;
  isEditable: boolean;
  purchaseConfirm: boolean;
  storePurchaseHistoryUUID : string;
}

const initialState = {
  uuid: '',
  title: '',
  description: '',
  curriculum: 0,
  tags: [],
  folderUUID: '',
  isOwner: true,
  exportable: true,
  readable: true,
  isPurchased: false,
  isEditable: false,
  purchaseConfirm: false,
  storePurchaseHistoryUUID: '',
  grade: 0,
  subject: 0,
} as ISaveState;

const saveSlice = createSliceSteamup(
  'save',
  initialState,
  {
    init() {
      return initialState;
    },
    pushTag(state, { payload }: PayloadAction<number>) {
      if (!state.tags.includes(payload)) {
        state.tags.push(payload);
      }
    },
    removeTag(state, { payload }: PayloadAction<number>) {
      state.tags = state.tags.filter((id) => id !== payload);
    },
  },
);

export default saveSlice;
